import LegalPage from "../components/layout/LegalPage";
import { PRIVACY_SECTIONS, LEGAL_EFFECTIVE_DATE } from "../data/legalData";

const PrivacyPage = () => (
    <LegalPage
        title="Privacy Policy"
        effectiveDate={LEGAL_EFFECTIVE_DATE}
        sections={PRIVACY_SECTIONS}
    />
);

export default PrivacyPage;
